export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/8ef8fa070df957526beb6f108087c0f7.png";